
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum DashboardType {
	Information = 0,
	Absence = 1
}
export namespace DashboardType {
	export function getKeys(): Map<DashboardType, string> {
		return new Map([[0, 'Information'], [1, 'Absence']]);
	}
}
